import { BehaviorSubject } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { Paging } from '../models/paging-model';

export const service = new InjectionToken<any>('service');
export interface PagingService {
  glopalPaging: BehaviorSubject<any>;
  getByPaging(pagingObj: Paging);
}
